import { createFileRoute } from "@tanstack/react-router";

import Results from "~/pages/UsdaAudit/Results";
import { ROUTE_STATIC } from "~/utils/routeStaticData";

export const Route = createFileRoute("/_private/usda-audit/results")({
  staticData: ROUTE_STATIC.usdaAudit,
  component: Results,
});
